import { AvatarProps } from '@mui/material';
import { useField } from 'react-final-form';
import useImageUpload from '../hooks/useImageUpload';
import AvatarUpload from './AvatarUpload';

type RFFAvatarUploadProps = {
  name: string;
  avatarProps: AvatarProps;
};

const RFFAvatarUpload = ({ name, avatarProps }: RFFAvatarUploadProps) => {
  const imageUpload = useImageUpload();
  const avatarField = useField(name);

  const handleUploadAvatar = async (file: File) => {
    const imageUrl = await imageUpload.uploadImage(file);
    avatarField.input.onChange(imageUrl);
  };

  return (
    <AvatarUpload
      avatarProps={avatarProps}
      proccessFile={handleUploadAvatar}
      imageUrl={avatarField.input.value}
    />
  );
};

export default RFFAvatarUpload;
